import {
  ListChainQuery,
  ListChainDocument,
  GetChainPaymentMethodQuery,
  GetChainPaymentMethodDocument,
  GetChainQuery,
  GetChainDocument,
} from "@/generated/graphql";
import { ApolloQueryResult } from "@apollo/client/core";
import { generateApolloClient } from "../apolloClientUtil";

/**
 * チェーン情報を取得する
 * @param customerCode カスタマーコード
 * @returns チェーン情報
 */
export async function getChainList(customerCode: string): Promise<
  | (
      | {
          __typename?: "Chain" | undefined;
          chain_code: string;
          name: string;
        }
      | null
      | undefined
    )[]
  | null
  | undefined
> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();

    const listChain: ApolloQueryResult<ListChainQuery> =
      await apolloClient.query<ListChainQuery>({
        query: ListChainDocument,
        variables: {
          customer_code: customerCode,
        },
        fetchPolicy: "no-cache",
      });
    return listChain.data.listChain;
  } catch (err: unknown) {
    console.error(err);

    if (err instanceof Error) {
      err.message = "チェーン情報の取得に失敗しました。";
      throw err;
    } else {
      throw new Error("チェーン情報の取得に失敗しました。（Unknown error）");
    }
  }
}

/**
 * チェーン情報を取得する
 * @param customerCode カスタマーコード
 * @returns チェーン情報
 */
export async function getChainInfo(
  customerCode: string,
  chain_code: string
): Promise<
  | {
      __typename?: "Chain" | undefined;
      customer_code: string;
      chain_code: string;
      name: string;
      max_unit?: number | null | undefined;
      cognito_user_pool_id?: string | null | undefined;
      cognito_user_client_id?: string | null | undefined;
      house_card_display?: number | null | undefined;
      house_card_validation?: string | null | undefined;
      operator_column_email: number;
      operator_column_tel: number;
      register_no_max_length: number;
      receipt_no_max_length: number;
      charter_admin_send_address?: string | null | undefined;
      is_hide_delivery_time_on_spot: number;
      is_hide_other_shop_members: number;
      is_delivery_address1_display: number;
      use_receipt_barcode_search_flg: number;
      idle_logout_seconds?: number | null | undefined;
      created_date: string;
      created_user_id: string;
      updated_date?: string | null | undefined;
      updated_user_id?: string | null | undefined;
    }
  | null
  | undefined
> {
  // ローカルストレージが空等で必須パラメータが取得できない場合はAPI呼び出しをスキップ
  if (!customerCode || !chain_code) {
    console.warn("[getChainInfo] customerCode または chain_code が空のため、API呼び出しをスキップします。");
    return null;
  }

  try {
    //graphql接続
    const apolloClient = await generateApolloClient();

    const getChain: ApolloQueryResult<GetChainQuery> =
      await apolloClient.query<GetChainQuery>({
        query: GetChainDocument,
        variables: {
          customer_code: customerCode,
          chain_code: chain_code,
        },
        fetchPolicy: "no-cache",
      });
    return getChain?.data.getChain;
  } catch (err: unknown) {
    console.error(err);

    if (err instanceof Error) {
      err.message = "チェーン情報の取得に失敗しました。";
      throw err;
    } else {
      throw new Error("チェーン情報の取得に失敗しました。（Unknown error）");
    }
  }
}

/**
 * 支払情報を取得する
 * @param customerCode カスタマーコード
 * @param chainCode チェーンコード
 * @returns 支払情報
 */
export async function getChainPaymentMethod(
  customerCode: string,
  chainCode: string
): Promise<
  | (
      | {
          __typename?: "ChainPaymentMethod" | undefined;
          chain_code: string;
          created_date: string;
          created_user_id: string;
          customer_code: string;
          payment_amount_required: string;
          payment_method: string;
          sort_order: number;
          updated_date?: string | null | undefined;
          updated_user_id?: string | null | undefined;
        }
      | null
      | undefined
    )[]
  | null
  | undefined
> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();

    const paymentList: ApolloQueryResult<GetChainPaymentMethodQuery> =
      await apolloClient.query<GetChainPaymentMethodQuery>({
        query: GetChainPaymentMethodDocument,
        variables: {
          chain_code: chainCode,
          customer_code: customerCode,
        },
        fetchPolicy: "no-cache",
      });
    return paymentList.data.getChainPaymentMethod;
  } catch (err: unknown) {
    console.error(err);

    if (err instanceof Error) {
      err.message = "支払情報の取得に失敗しました。";
      throw err;
    } else {
      throw new Error("支払情報の取得に失敗しました。（Unknown error）");
    }
  }
}
